module.exports = __webpack_public_path__ + "img/virus.2aa3d4d1.svg";